var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{blue: _vm.color === 'blue',fullWidth:_vm.fullWidth},attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }